var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2209_9060",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2209_9060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 17.8662L9.46673 24.3996C9.22229 24.644 8.91118 24.7662 8.5334 24.7662C8.15562 24.7662 7.84451 24.644 7.60007 24.3996C7.35562 24.1551 7.2334 23.844 7.2334 23.4662C7.2334 23.0885 7.35562 22.7774 7.60007 22.5329L14.1334 15.9996L7.60007 9.46624C7.35562 9.2218 7.2334 8.91069 7.2334 8.53291C7.2334 8.15513 7.35562 7.84402 7.60007 7.59958C7.84451 7.35513 8.15562 7.23291 8.5334 7.23291C8.91118 7.23291 9.22229 7.35513 9.46673 7.59958L16.0001 14.1329L22.5334 7.59958C22.7778 7.35513 23.089 7.23291 23.4667 7.23291C23.8445 7.23291 24.1556 7.35513 24.4001 7.59958C24.6445 7.84402 24.7667 8.15513 24.7667 8.53291C24.7667 8.91069 24.6445 9.2218 24.4001 9.46624L17.8667 15.9996L24.4001 22.5329C24.6445 22.7774 24.7667 23.0885 24.7667 23.4662C24.7667 23.844 24.6445 24.1551 24.4001 24.3996C24.1556 24.644 23.8445 24.7662 23.4667 24.7662C23.089 24.7662 22.7778 24.644 22.5334 24.3996L16.0001 17.8662Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.b929869feb1db2a80828d5cf2639a9e5.svg";
export { ForwardRef as ReactComponent };